"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NumberFormatInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactNumberFormat = _interopRequireDefault(require("react-number-format"));
var _Input = require("./Input");
var _excluded = ["value", "defaultValue", "component", "decimals", "onChange"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var MAX_INTEGER_PART_LENGTH = 10;
var NumberFormatInput = function NumberFormatInput(_ref) {
  var value = _ref.value,
    defaultValue = _ref.defaultValue,
    Component = _ref.component,
    decimals = _ref.decimals,
    onChange = _ref.onChange,
    props = _objectWithoutProperties(_ref, _excluded);
  var formatted = value !== null && value !== void 0 ? value : defaultValue;
  return /*#__PURE__*/_react.default.createElement(_reactNumberFormat.default, _extends({
    value: formatted,
    isAllowed: function isAllowed(_ref2) {
      var value = _ref2.value;
      return value.charAt(0) !== '.' && (value.length <= MAX_INTEGER_PART_LENGTH || value.charAt(MAX_INTEGER_PART_LENGTH) === '.');
    },
    allowNegative: false,
    thousandSeparator: " ",
    decimalSeparator: ".",
    isNumericString: true,
    decimalScale: decimals,
    customInput: _Input.Input,
    displayType: 'input',
    onValueChange: function onValueChange(_ref3) {
      var value = _ref3.value;
      // remove trailing dot
      if (value.charAt(value.length - 1) === '.') value = value.substring(0, value.length - 1);
      if (onChange) onChange({
        target: {
          value: value
        }
      });
    }
  }, props));
};
exports.NumberFormatInput = NumberFormatInput;